import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import urls from '@src/@core/auth/jwt/urls'
import axios from 'axios'

export const getAllData = createAsyncThunk('appPaymentsGateway/getAllData', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instanceGet.get(`integrations/paylinks/get_trackable_transactions/`, {
    params: {
      p: params.page,
      profile_id: params.profile_id,
      idCustomer: params.idCustomer,
      start: params.start,
      end: params.end,
      status: params.status,
      cost_center: params.cost_center,
      origin: params.origin,
      channel: params.channel
    }
  })
  return response
})

export const getPaymentGateway = createAsyncThunk('appPaymentsGateway/getPaymentGateway', async (id) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instanceGet.get(`integrations/paylinks/${id}/`)
  return response
})

export const getPaymentGatewayRecurrent = createAsyncThunk('appPaymentsGateway/getPaymentGatewayRecurrent', async (id) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instanceGet.get(`integrations/paylinks/recurrent/${id}/`)
  return response
})

export const getDocumentsBySubscription = createAsyncThunk('appSubscriptions/getDocumentsBySubscription', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instance.get(`/integrations/documents_by_payments/${id}`)
  return response.data
})
export const getDocumentsBySubscriptionRecurrent = createAsyncThunk('appSubscriptions/getDocumentsBySubscriptionRecurrent', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instance.get(`/integrations/documents_by_payments_recurrent/${id}`)
  return response.data
})

export const setIsFetchingResults = createAsyncThunk('appPaymentsGateway/setIsFetchingResults', () => {
  return "fetching"
})

export const appPaymentsGatewaySlice = createSlice({
  name: 'appPaymentsGateway',
  initialState: {
    allData: [],
    total: 1,
    selectedPayment: null,
    selectedPaymentRecurrent: null,
    isFetching: false,
    documents: [],
    totalDocuments: 0,
    documentsRecurrent: [],
    totalDocumentsRecurrent: 0
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllData.fulfilled, (state, action) => {
        const results = action.payload.data
        state.allData = results.results
        state.total = results.count
        state.isFetching = false
      })
      .addCase(getPaymentGateway.fulfilled, (state, action) => {
        state.selectedPayment = action.payload.data
        state.isFetching = false
      })
      .addCase(getPaymentGatewayRecurrent.fulfilled, (state, action) => {
        state.selectedPaymentRecurrent = action.payload.data
        state.isFetching = false
      })
      .addCase(setIsFetchingResults.fulfilled, (state) => {
        state.isFetching = true
      })
      .addCase(getDocumentsBySubscription.fulfilled, (state, action) => {
        state.documents = action.payload
        state.totalDocuments = action.payload.length
      })
      .addCase(getDocumentsBySubscriptionRecurrent.fulfilled, (state, action) => {
        state.documentsRecurrent = action.payload
        state.totalDocumentsRecurrent = action.payload.length
      })
  }
})

export default appPaymentsGatewaySlice.reducer